import BaseService from './BaseService';

class MenuService extends BaseService {
    getMenu = () => this.get('/warehouse/menu');
}

export default new MenuService();
